import InteractionNode from "../models/interactions/InteractionNode";
// import InteractionNodes from "../models/interactions/interactionNodes";

import Interaction from "../models/interactions/Interaction";
import IntervalSet from "../models/communications/IntervalSet";

// import Interactions from "../models/interactions/interactions";
import { Dictionary } from "@reduxjs/toolkit";
import { compareIntervalsByDay } from "./DataUpdateHelper";
import Interval from "../models/communications/Interval";
// import IntervalSets from "../models/communications/intervalSets";

// takes an IntervalSets object, a flat top-level object which represents relational db data
// these types of objects are easiest to manipulate
// data must be organically nested for top rendering efficiency
export function transformDataFlatToNested(
  rootIntervalSetID: string,
  intervalSets: Array<IntervalSet>,
  dictionary: Dictionary<any>,
) {
  // this will always be provided
  // TODO could be any id, but in this case it's 0 for testing

  const intervalSetsDeepCopy = JSON.parse(JSON.stringify(intervalSets)); // make a deep copy so we're not mutating original state refs

  Object.keys(intervalSetsDeepCopy).forEach((key) => {
    // grab the interaction corresponding to the nodeID, and store that
    // get all direct children of this node
    // Object.keys(intervalSetsDeepCopy).forEach(key => {
    //     let tempThisNode = intervalSetsDeepCopy[key];
    //     let tempThisInteraction = intervalSetsDeepCopy[tempThisNode.child]
    // })
    // parse through all nodes
    // -if a node has a parent listed
    //    -grab that parent interaction from the dict
    //         -if no children currently added to parent, make new array
    //    -push chilcren to children prop on parent interaction (not node)
    // if (thisNode.parent) {
    //     var parent = dictionary[thisNode.parent];
    //     if (parent) {
    //         if (!parent.children) {
    //             parent.children = [];
    //         }
    //         parent.children.push(thisInteraction);
    //     }
    // }
  });

  // delete the remaining child items that are still appearing as flat refs on the top-level of the dict
  // TODO - there's probably a better/more eloquent/more efficient way to handle this in the code above
  //        instead of after the fact
  // console.log(interactionNodesDeepCopy);
  // Object.keys(interactionNodesDeepCopy).forEach(key => {
  //     let thisNode = interactionNodesDeepCopy[key];
  //     let thisInteraction = interactionsDeepCopy[thisNode.child]

  //     if (thisNode.parent != rootInteractionID) {
  //         // https://www.tutorialspoint.com/Remove-elements-from-a-Dictionary-using-Javascript
  //         delete dictionary[thisInteraction.id];
  //     }

  // })

  // console.log("Returned Results from transformDataFlatToNested(): ");
  // console.log(dictionary);
  return dictionary;
}

export function addNestedChildrenToArray(obj: any, resultArray: any) {
  resultArray.push(obj.id);
  obj.children.forEach((child: any) =>
    addNestedChildrenToArray(child, resultArray),
  );
}

// produces an array of InteractionNodes that are children of the given parent
export function getChildrenForFlatInteraction(
  interactionNodeID: string,
  interactionNodes: Array<InteractionNode>,
  interactions: Array<Interaction>,
) {
  // this will always be provided
  // TODO could be any id, but in this case it's 0 for testing
  interactionNodeID = "1";
  const interactionNodesDeepCopy = JSON.parse(JSON.stringify(interactionNodes)); // make a deep copy so we're not mutating original state refs
  const interactionsDeepCopy = JSON.parse(JSON.stringify(interactions)); // make a deep copy so we're not mutating original state refs

  const resultArray: Array<Interaction> = [];

  // // grab the node data for the interaction
  const thisNode = interactionNodesDeepCopy[interactionNodeID];

  // // grab the interaction corresponding to the nodeID, and store that
  // thisInteraction.id is the parent we need to match
  const thisInteraction = interactionsDeepCopy[thisNode.child_interaction_id];

  // get all direct children of this node
  Object.keys(interactionNodesDeepCopy).forEach((key) => {
    const tempThisNode = interactionNodesDeepCopy[key];

    if (parseInt(thisInteraction.id) === parseInt(tempThisNode.parent_interaction_id)) {
      // console.log("TRUE")
      // dictionary[thisInteraction.id] = thisInteraction;
      resultArray.push(tempThisNode);
    }
  });

  return resultArray;
}

export const addChildrenToFlatNodes = (
  interactionNodes: Array<InteractionNode>,
  interactions: Array<Interaction>,
) => {
  // const dispatch = useStoreDispatch();

  const interactionNodesDeepCopy = JSON.parse(JSON.stringify(interactionNodes)); // make a deep copy so we're not mutating original state refs

  // get all direct children of this node
  Object.keys(interactionNodesDeepCopy).forEach((key) => {
    const tempThisNode = interactionNodesDeepCopy[key];

    // let tempThisInteraction = interactionsDeepCopy[tempThisNode.child]

    const children = getChildrenForFlatInteraction(
      tempThisNode.id,
      interactionNodes,
      interactions,
    );
    // console.log(children)
    interactionNodesDeepCopy[key].children = children;

    // this isn't working right now? will need to fix:
  });

  // console.log(interactionNodesDeepCopy);
  return interactionNodesDeepCopy;
};

export const addInteractionsToInteractionNodes = (
  interactionNodes: Array<InteractionNode>,
  interactions: Array<Interaction>,
) => {
  // const dispatch = useStoreDispatch();

  const interactionNodesDeepCopy = JSON.parse(JSON.stringify(interactionNodes)); // make a deep copy so we're not mutating original state refs
  const interactionsDeepCopy = JSON.parse(JSON.stringify(interactions)); // make a deep copy so we're not mutating original state refs

  // get all direct children of this node
  Object.keys(interactionNodesDeepCopy).forEach((key) => {
    const tempThisNode = interactionNodesDeepCopy[key];
    const tempThisInteraction = interactionsDeepCopy[tempThisNode.child_interaction_id];
    interactionNodesDeepCopy[key].interaction = tempThisInteraction;
  });

  // console.log(interactionNodesDeepCopy);
  return interactionNodesDeepCopy;
};

// find which commSet has the earliest startDay
// return earliest startday for a given commset
// by finding the interval attached to that commset
// which has the earliest startday
export const findCommSetEarliestStartDay = (commSetID: number | null, associatedIntervals: Array<Interval>) => {
  const intervalsForThisCommSetID = associatedIntervals.filter((associatedInterval) => {
      return associatedInterval.communication_set_id === commSetID
  })
  intervalsForThisCommSetID.sort(compareIntervalsByDay);

  let result : number | null = 0;
  if(intervalsForThisCommSetID && intervalsForThisCommSetID.length > 0 ){
      result =  intervalsForThisCommSetID[0].start_day;
       // transform back to 0 to make the in-scope calculations faster
      if(result === null){
        result = 0
      }
  }

  return result;
}

// for a given commSetID, return all corresponding intervals into array ordered by startDay
export const getOrderedIntervalsForCommSet = (commSetID:number | null, associatedIntervals: Array<Interval>) =>{
  const intervalsForThisCommSet = associatedIntervals.filter((interval)=>{
    return interval.communication_set_id === commSetID
  })
  if(intervalsForThisCommSet && intervalsForThisCommSet.length>0){
    return intervalsForThisCommSet.sort(compareIntervalsByDay)
  } else {
    return [];
  }
}


export const getColspanFromAssociatedIntervalsByCommSetID: any = (commSetID: number | null, associatedIntervals: Array<Interval>) => {
  let filteredAssociatedIntervals: Array<Interval> = []
  if (commSetID) {
      filteredAssociatedIntervals = associatedIntervals.filter((associatedInterval) => {
          return associatedInterval.communication_set_id === commSetID
      })
  } else {
      filteredAssociatedIntervals = associatedIntervals.filter((associatedInterval) => {
          return associatedInterval.communication_set_id === null
      })
  }

  return filteredAssociatedIntervals.length

}
